import { CreateWorksheetSelector } from 'Components/Worksheets/Core/types';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { ConstantDryMassEntryOption } from './types';

/**
 * Creates a selector that will return the laboratory option for Constant Dry Mass Entry, given a worksheet selector creator
 */
export const createDryMassEntryOptionSelector = (createWorksheetSelector: CreateWorksheetSelector) =>
  pipe(
    createWorksheetSelector!('header.Laboratory.Options.ConstantDryMassEntry', false),
    (v) => v as ConstantDryMassEntryOption,
    valueOrDefault('Never' as ConstantDryMassEntryOption)
  );
